export default "__VITE_ASSET__H8yhpgBN__"